import { OverviewFilter, OverviewSortState } from '../types'

export const getDefaultSort = (isUnifiedShipmentsEnabled: boolean) =>
  isUnifiedShipmentsEnabled ? { field: 'relevance', direction: 'asc' } : { field: 'createdDate', direction: 'desc' }

export const decodeFilter = (filter: string | undefined): OverviewFilter => {
  try {
    return filter ? JSON.parse(filter) : {}
  } catch {
    return {}
  }
}

export const encodeFilter = (sort: OverviewFilter): string => JSON.stringify(sort)

export const decodeSort = (
  sort: string | undefined,
  defaultSort: {
    field: string
    direction: string
  }
): OverviewSortState => {
  try {
    return sort ? JSON.parse(sort) : defaultSort
  } catch {
    // @ts-expect-error no relevance outside ff
    return defaultSort
  }
}

export const encodeSort = (sort: OverviewSortState): string => JSON.stringify(sort)
